import { combineReducers } from 'redux';
import {reducer as toastrReducer} from 'react-redux-toastr';
import { library } from './library.reducer';
import { smsCourse } from './sms-course.reducer';
import { courseHome } from './course-home.reducer';
import { topic } from './topic.reducer';
import { playlist } from './playlist.reducer';
import { video } from './video.reducer';
import {courseSetting} from './course-settings.reducer'
const rootReducer = combineReducers({
  library,
  smsCourse,
  courseHome,
   toastr: toastrReducer,
  topic,
  playlistReducer : playlist,
  video,
  courseSetting
});

export default rootReducer;


// WEBPACK FOOTER //
// ./src/_reducers/index.js